import { IconButton, Tooltip } from "@material-ui/core"
import { useDispatch } from "react-redux"
import HotelIcon from '@material-ui/icons/House'
import { openModalHotelPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck"

const BHotel = (props) => {
    const { paquete } = props
    const dispatch = useDispatch()
    const handleClick = () => {
        dispatch(openModalHotelPaqueteTerrestre({
          paquete
        }))
    }

    return (
        <Tooltip title="Hoteles">
            <IconButton aria-label="Declinar solicitud" onClick={handleClick}>
                <HotelIcon color="primary" />
            </IconButton>
        </Tooltip>
    )
}

export default BHotel